<script>
  import { max, ascending } from 'd3-array';
  import dataRaw from './lib/data.json';
  import { categoriesById } from './lib/categories';
  import { format } from './lib/utils';
  import Buttons from './components/Buttons.svelte';
  import Legend from './components/Legend.svelte';
  const data = JSON.parse(JSON.stringify(dataRaw));
  const m = max(data, d => d.preis_pro_kilo_co2);
  data.sort((a, b) => ascending(a.preis_pro_kilo_co2, b.preis_pro_kilo_co2));


  const frmt0 = format(0, true);
  const frmt1 = format(1, true);

  const SHOW_INFO = false;

  data.forEach((d) => {
    let unit = d['unit_orig'];
    let val = d['amount_for_kilo_co2'];
    if (unit === 'g' && val > 1000) {
      unit = 'kg';
      val = val / 1000;
    }
    unit = unit === 'Stück' ? '' : unit + ' ';
    const f = unit === 'g ' ? frmt0 : frmt1;
    d.amount = `${f(val)}${unit}`;

  });


  const frmt = format(2, true);


  let view = 'selection';
  const options = [
    { label: 'Auswahl', value: 'selection' },
    { label: 'Alle Produkte', value: 'all' },
  ];

</script>


<div class="barchart" class:selection={view==='selection'}>
  <div class="barchart-toggle">
    <Buttons bind:value={view} {options} />
  </div>

  <div class="barchart-content">
  {#each data as d, i (i)}
    <div class="barchart-item" class:hidden={!d.selection} class:hidden-m={!d.selection_mobile}>
      <div class="barchart-item__content">
        <div class="barchart-item__label-container">
          <div class="barchart-item__icon" style:background-image={`url('${PATH}/food-icons-min/${d.id}.svg')`}></div>
          <div class="barchart-item__name" style:background-color={categoriesById[d.category].color}>
            {d.name}
          </div>
        </div>
        <div class="barchart-item__bar-container">
          <div class="barchart-item__bar-wrapper">
            <div class="barchart-item__bar" style:width={d.preis_pro_kilo_co2/m*100+'%'}>
              <div class="barchart-item__value" class:inside={d.preis_pro_kilo_co2/m > 99}>
                <span class="value">
                {frmt(d.preis_pro_kilo_co2)} €
                {#if i === 0}
                  für ein Kilo CO₂
                {/if}
                </span>
                {#if SHOW_INFO}
                <span class="info">
                  ({d.amount} {d.name_plural || d.name})
                </span>
                {/if}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  {/each}
  </div>

  <div class="barchart-legend">
    <Legend />
  </div>



</div>

<style>

  .barchart {
    background-color: #dedede;
    border-radius: 6px;
    font-family: "Franklin Gothic FS", Helvetica, Arial, sans-serif;
    font-size: 16px;
    line-height: 24px;
    overflow: hidden;
  }

  .barchart-content {
    padding: 15px;
  }

  .barchart-item {
    height: 42px;
    transition: height 0.7s ease;
    overflow: hidden;
  }


  .barchart-item__content {
    height: 42px;
    display: flex;
    opacity: 1;
    transition: opacity 0.8s ease;
    transition-delay: 0.3s;
  }

  .barchart-item__label-container {
    flex: 0 0 205px;
    position: relative;
    display: flex;
    align-items: center;
  }

  .barchart-item__icon {
    background-color: #fff;
    height: 32px;
    width: 32px;
    border-radius: 50%;
    background-size: 26px;
    background-position: center center;
    background-repeat: no-repeat;
    margin-right: 10px;
  }

  .barchart-item__name {
    font-weight: 500;
    white-space: nowrap;
    padding: 0 5px;
    border-radius: 2px;
  }


  .barchart-item__bar-container {
    flex: 1 0 1px;
    position: relative;
    padding-right: 90px;
  }

  .barchart-item__bar-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .barchart-item__bar {
    height: 20px;
    background-color: #666;
    border-radius: 1px;
    position: absolute;
    min-width: 1px;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    background: repeating-linear-gradient(
      45deg,
      #666 0px,
      #666 5px,
      #555 5px,
      #555 10px
    );
  }


  .barchart-item__value {
    white-space: nowrap;
    position: absolute;
    left: 100%;
    padding: 0 7px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 14px;
    font-weight: 500;

  }

  .barchart-item__value.inside {
    left: 0;
    color: #fff;
  }


  .barchart-toggle {
    background: #ededed;
    padding: 20px 0 20px;
  }

  .barchart-legend {
    margin: 20px 0 10px 0;
  }

  .barchart.selection .barchart-item.hidden {
    height: 0;
    transition-delay: 0.3s;
    transition-duration: 0.9s;
  }

  .barchart.selection .barchart-item.hidden .barchart-item__content {
    opacity: 0;
    transition-delay: 0;
    transition-duration: 0.3s;
  }
  
  .value {
    display: block;
    line-height: 20px;
  }

  .info {
    display: block;
    font-size: 12px;
    line-height: 13px;
    font-weight: normal;
    opacity: 0.6;
  }

  @media (max-width: 480px) {
    .barchart {
      font-size: 14px;
      line-height: 17px;
    }

    .barchart-content {
      padding: 15px 10px;
    }

    .barchart-item__label-container {
      flex: 0 0 170px;
    }

    .barchart-item__icon {
      height: 36px;
      width: 36px;
      background-size: 30px;
      margin-right: 7px;
    }
    .barchart-item__bar-container {
      padding-right: 90px;
    }
    .barchart-item {
      height: 42px;
    }

    .barchart-item__content {
      height: 42px;
    }

    .barchart.selection .barchart-item.hidden-m {
      height: 0;
      transition-delay: 0.3s;
      transition-duration: 0.9s;
    }

    .barchart.selection .barchart-item.hidden-m .barchart-item__content {
      opacity: 0;
      transition-delay: 0;
      transition-duration: 0.3s;
    }
  }
</style>
